/* eslint-disable */
import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const generateSubmitFundStatusChangesUrl = ({ selectedFiduciary }) => {
  /* eslint-disable-next-line max-len */
  const url = `/pendingfiduciaryfunds/${selectedFiduciary}/submit`;
  return url;
};

export const submitFundStatusChangesToProduction = async ({
  selectedFiduciary,
  payload,
}) => {
  const url = generateSubmitFundStatusChangesUrl({ selectedFiduciary });
  return request.post(url, payload);
};
